import { Outlet } from "react-router-dom";
import { AppLayout } from "@etframework/ui.components";
import useIsMounted from "../hooks/useIsMounted";
import { IconLoading } from "../components/Loading/IconLoading";
import DueDatesAppheader from "./components/DueDatesAppHeader";
import { SettingsNavigation } from "./components/Settings/SettingsNavigation";

//Portals
import { TaskTemplateModal } from "./portals/TaskTemplateModal";
import Notification from "./portals/Notification";
import { CreateTaskTypeModal } from "./portals/CreateTaskTypeModal";
import { DeleteTaskTypeConfirmationModal } from "./portals/DeleteTaskTypeConfirmationModal";
import { CreateStageModal } from "./portals/CreateStageModal";
import { UpdateStageModal } from "./portals/UpdateStageModal";
import { CreateBoardModal } from "./portals/CreateBoardModal";
import { AccessModal } from "./portals/AccessModal";
import { DeleteBoardConfirmationModal } from "./portals/DeleteBoardConfirmationModal";
import { ArchiveBoardConfirmationModal } from "./portals/ArchiveBoardConfirmationModal";
import { WelcomeModal } from "./portals/WelcomeModal";
import { ImportTaskTemplatesLogOverlay } from "./portals/ImportTasksTemplatesLogOverlay";
import { CreateTaxReturnTaskTypeModal } from "./portals/CreateTaxReturnTaskTypeModal";

//Providers
import { useTranslation } from "react-i18next";
import { CustomFieldGroupModal } from "./portals/CustomFieldGroupModal";
import { DeleteGroupConfirmationModal } from "./portals/DeleteGroupConfirmationModal";
import { InactivateFieldGroupModal } from "./portals/InactivateFieldGroupModal";
import { DeleteTaskTemplateConfirmationModal } from "./portals/DeleteTaskTemplateConfirmationModal";
import { ImportTasksTemplatesModal } from "./portals/ImportTaskTemplatesModal";

const SettingsLayout = () => {
  const { t } = useTranslation(["SettingsLayout"]);
  const isMounted = useIsMounted(true);

  if (!isMounted) return <IconLoading />;

  return (
    <AppLayout className="duedates-settings-layout">
      <AppLayout.Header>
        <DueDatesAppheader />
      </AppLayout.Header>

      <AppLayout.ContentRow>
        <div className="container-fluid">
          <div className="row et-settings-nav h-100">
            <div className="module-layout d-flex flex-fill me-3 mb-3 h-100">
              <div className="col-2">
                <div className="me-4">
                  <div className="header-title sidebar-header fw-bold my-4">
                    <div className="d-flex align-items-center settings-title-label fw-bold">
                      {t("Navigation.DueDatesSettings")}
                    </div>
                  </div>
                  <div className="d-flex side-bar-container active">
                    <SettingsNavigation />
                  </div>
                </div>
              </div>

              <div className="col-10">
                <div className="d-flex flex-column h-100 w-100">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </AppLayout.ContentRow>
      <AppLayout.Portals>
        <ImportTaskTemplatesLogOverlay />
        <CreateBoardModal />
        <CreateTaskTypeModal />
        <CreateTaxReturnTaskTypeModal />
        <DeleteTaskTypeConfirmationModal />
        <CreateStageModal />
        <UpdateStageModal />
        <TaskTemplateModal />
        <DeleteBoardConfirmationModal />
        <ArchiveBoardConfirmationModal />
        <AccessModal />
        <CustomFieldGroupModal />
        <DeleteGroupConfirmationModal />
        <InactivateFieldGroupModal />
        <DeleteTaskTemplateConfirmationModal />
        <ImportTasksTemplatesModal />
        {/* Add above here */}
        <Notification />
        <WelcomeModal />
      </AppLayout.Portals>
    </AppLayout>
  );
};

export default SettingsLayout;
